<template>
 <div class="">
    <div v-if="errorStatus" class="alert alert-danger my-3" role="alert" v-html="errorStatus">
    </div>
    <div v-else-if="isLoading" class="d-flex align-items-center justify-content-center" style="min-height:300px">
        <div class="spinner-border mx-2" style="width: 3rem; height: 3rem;" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
        Loading...
    </div>
    <div v-else-if="noData">
      <div v-if="errorStatus" class="alert alert-info my-3" role="alert">
        No data available.
      </div>
    </div>
    <div v-else-if="!selectedLocation" class="row justify-content-md-center">
      <div class="col-12 col-lg-8 ">
        <h5>Please add a location to get started</h5>
        <div class="input-group">
          <div class="btn px-1 disabled" >
            <i class="bi bi-geo"></i>
          </div>
          <input v-model="newLocation" v-on:keyup.enter="setLocation()" class="form-control border-end-0  border-primary" type="text" placeholder="Enter a location" aria-describedby="locationHelpBlock">
          <span class="input-group-append">
              <button @click="setLocation()" class="btn btn-primary  border-start-0 border-primary ms-n1" :class="{disabled:!newLocation}" type="button" >
                  <i class="bi bi-search"></i>
              </button>
          </span>
        </div>
      </div>
    </div>
    <div v-else class="row justify-content-md-center">
      <div class="col-12">
        <div class="row align-items-center">
          <h3 class="h3 col-12 col-md-6">QA Dashboard for 
              <VcLocationChooser 
                :selectedLocation="selectedLocation"
                @location-selected="setLocation" />
              
          </h3> 
          <div class="col-12 col-md-6">
            <DateRangeChooser :queryDefinition="queryDefn" :queryData="queryData" @change:daterange="setDateRange" />
          </div>
         
          <!--
          <div class="btn-group  ms-auto" role="group" aria-label="Solid button group">
            <button type="button" class="btn btn-outline-primary btn-sm" :class="{active:unitGroup==='us'}" @click="setUnitGroup('us')">F</button>
            <button type="button" class="btn btn-outline-primary btn-sm" :class="{active:unitGroup==='metric'}" @click="setUnitGroup('metric')">C</button>
          </div>

          -->
        </div>
        <h5>Query parameters</h5>
        <div class="row">
          <div class="mb-3 col-1">
            <input type="text" class="form-control form-control-sm" placeholder="unitGroup"  v-model="queryDefn.unitGroup"  >
            <small class="form-text text-muted">UnitGroup</small>
          </div>
          <div class="mb-3 col-2">
            <input type="text" class="form-control form-control-sm" placeholder="Include"  v-model="queryDefn.include"  >
            <small class="form-text text-muted">Include</small>
          </div>
       
         
          <div class="mb-3 col-8">
            <textarea  class="form-control form-control-sm" placeholder="Elements"  v-model="queryDefn.elements"  rows="2"></textarea>
            <small class="form-text text-muted">Elements</small>
          </div>
          <div class="mb-3 col-1">
             <button type="submit" class="btn btn-primary btn-sm" @click="refreshData()">Submit</button>
          </div>

          <div class="mb-3 col-2">
            <input type="text" class="form-control form-control-sm" placeholder="Options"  v-model="queryDefn.options"  >
            <small class="form-text text-muted">Options</small>
          </div>
          <div class="mb-3 col-2">
            <input type="text" class="form-control form-control-sm" placeholder="Max Distance"  v-model="queryDefn.maxDistance"  >
            <small class="form-text text-muted">Max Distance</small>
          </div>
          <div class="mb-3 col-2">
            <input type="text" class="form-control form-control-sm" placeholder="Max Stations"  v-model="queryDefn.maxStations"  >
            <small class="form-text text-muted">Max Stations</small>
          </div>
          <div class="mb-3 col-2">
            <input type="text" class="form-control form-control-sm" placeholder="Elevation Difference"  v-model="queryDefn.elevationDifference"  >
            <small class="form-text text-muted">Elevation Difference</small>
          </div>
          
        </div>
         <h5>View options</h5>
        <div class="row mb-3">
          <div class="col-2">
            <select class="form-select form-select-sm" v-model="showBy" >
              <option value="station">Station</option>
              <option value="element">Element</option>
            </select>
            <small class="form-text text-muted">Show by</small>
          </div>
          <div  v-if="showBy==='element'" class="col-2">
            <select class="form-select form-select-sm" v-model="viewElement" >
              <option  v-for="elementTable in elementTables" :value="elementTable">{{elementTable.element}}</option>
            </select>
            <small class="form-text text-muted">Show by</small>
          </div>
        </div>

        <template v-if="showBy==='station'">
          <div v-for="table in tables">
            <h5>{{table.resolvedAddress}}</h5>
            <table class="table table-striped table-sm fs-xs">
              <thead>
              <tr><th v-for="col in columns">{{col}}</th></tr>
              </thead>
              <tbody>
                <tr v-for="d in tableRows(table)">
                  <td v-for="col in columns">{{d[col]}}</td>
                </tr>
              </tbody>
            </table>

          </div>
        </template>
        <template v-if="showBy==='element' && viewElement">
         <!-- <div v-for="elementTable in elementTables">-->
            <h5>{{viewElement.element}}</h5>
            <table class="table table-striped table-sm fs-xs elementTable">
             
              <thead>
                <tr>
                  <th>Date</th>
                  <th v-for="station in viewElement.locations"><div class="text-nowrap">{{station.resolvedAddress}}</div><div> {{format(station.stationDistance,0,true)}}m</div></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th>Max</th>
                   <td v-for="station in viewElement.locations">{{format(station['max'])}}</td>
                </tr>
                <tr>
                  <th>Min</th>
                  <td v-for="station in viewElement.locations">{{format(station['min'])}}</td>
                </tr>
                <tr v-if="showSum(viewElement.element)">
                  <th>Sum</th>
                  <td v-for="station in viewElement.locations">{{format(station['sum'])}}</td>
                </tr>
                <tr>
                  <th>Mean</th>
                  <td v-for="station in viewElement.locations">{{format(station['sum']/station['count'])}}</td>
                </tr>
                
                <tr>
                  <th>Count</th>
                  <td v-for="station in viewElement.locations">{{format(station['count'])}}</td>
                </tr>
                <tr>
                  <th>Count Non Zero</th>
                  <td v-for="station in viewElement.locations">{{format(station['countNonZero'])}}</td>
                </tr>
                <tr v-for="d in viewElement.dates">
                  <th>{{d}}</th>
                  <td v-for="station in viewElement.locations">{{station[d]}}</td>
                </tr>
              </tbody>
            
            </table>

         <!-- </div>-->
        </template>
      </div>
    </div>
    <CommonModals />
  </div>
</template>

<script>
import { VcLocationsStorage } from "/src/visualcrossing-core/vclocationsstorage";
import VcLocationChooser from "./VcLocationChooser.vue";
import "/src/visualcrossing-core/vccommunicator_serveradmin";
import CommonModals from '/src/components/CommonModals.vue'
import {VcDateUtils} from "/src/visualcrossing-core/vcdateutils";
import DateRangeChooser from '/src/components/DateRangeChooser.vue';
export default {
  name: 'loadermonitor',
  props: {
    
  },
  data() {
    return {
      noData:false,
      sessionId:null,
      sessionState:null,
      errorStatus:null,
      isLoading:false,
      selectedLocation:null,
      viewElement:null,
      //rooturl:null,
      basePeriodLabel:null,
      newLocation:null,
      locationsHistory:null,
      showAllColumns:false,
      showBy:"element",
      //queryDefinitions:[],
      queryDefn:{
        startdate:"last30days",
        enddate:null,
        include:"days,obs",
        options:"datadebug",
        elements:"datetime,tempmax,tempmin,temp,precip,windspeed,winddir,cloudcover,pressure,visibility,stations",
        unitGroup:"us",
        maxDistance:-1,
        maxStations:-1,
        elevationDifference:-1,
      },
      queryData:null,
      
    }
  },
  methods:{
    showSum(element) {
      return ["precip","snow"].includes(element);
    },
    format(value,decimals,separators) {

      if (!Number.isFinite(value) || isNaN(value) || value===Number.MIN_VALUE || value===Number.MAX_VALUE) {
        return "-";
      }

      decimals=(decimals>=0)?decimals:0;
     
      if (separators) {
        return value.toLocaleString('en-US', {maximumFractionDigits:decimals});
      }
      return value.toFixed(decimals);
    },
    refreshData() {
      let me=this;
     
      let queryDefn=JSON.parse(JSON.stringify(me.queryDefn));
      if (queryDefn.elements.indexOf("datetime")===-1) {
        queryDefn.elements+=",datetime";
      }

      if (queryDefn.elements.indexOf("stations")===-1) {
        queryDefn.elements+=",stations";
      }
      if (queryDefn.options.indexOf("datadebug")===-1) {
        queryDefn.options+=",datadebug";
      }
      me.queryData=null;
      vcCommunicator.retrieveTimelineData(queryDefn, me.selectedLocation.location, null, "json", true,false)
        .then(response => {
          me.queryData=response;
          
        }).catch((error) => {
          me.errorMessage=error;
      });
    },

    setDateRange(startPeriod, endPeriod) {
      
      let me=this;
     
      me.queryDefn.startdate=startPeriod;
      me.queryDefn.enddate=endPeriod;
      me.refreshData();
    },

    setLocation(newLocation) {
      
      var me=this;
      if (newLocation) {
        me.selectedLocation=newLocation;
      } else {
        me.selectedLocation={
          location:me.newLocation,
          name:null,
        };
      }
      
      me.newLocation=null;

      me.refreshData();
    },
   
    setUnitGroup(unitGroup) {
      var me=this;
      me.unitGroup=unitGroup
      //VcLocationsStorage.setUnitGroup(me.unitGroup);
      me.refreshData();
    },
    
    tableRows(table) {
      let me=this;
      if (!table || !table.days || !table.days.length) return [];
      if (me.isHours) {
        return table.days.reduce(function(a,d) {
          if (d && d.hours && d.hours.length) {
            d.hours.forEach(h=> {
            
            })
            a=a.concat(d.hours);
          }
          return a;
        },[])
      } else {
        return table.days;
      }
      
    },
    
  },
  computed:{
   
    isHours() {
      let me=this;
      return me.queryDefn && me.queryDefn.include && me.queryDefn.include.indexOf("hours")!==-1;
    },
    elementTables() {
      let me=this;
      let tables=me.tables;
      //me.viewElement=null;
      if (!tables) return [];
      
      let elements= me.queryDefn.elements.split(",");
      const hiddenElements=["datetime", "datetimeEpoch","stations"];
      elements=elements.filter(function(d) {
        return !hiddenElements.includes(d);
      });

      if ( me.viewElement && elements.indexOf(me.viewElement.element)===-1) {
          me.viewElement=null;
      }

      let retVal= elements.reduce(function(a, element) {
        let elementTable={
          element:element,
          locations:[],
          dates:[]
        };

        elementTable.locations=
          tables.reduce(function(a1, table) {


            let rows=me.tableRows(table);
            let elementRows=rows.reduce(function(a2, row, i) {

              if (i===0) {
                a2.count=0;
                a2.countNonZero=0;
                a2.max=Number.MIN_VALUE;
                a2.min=Number.MAX_VALUE;
                a2.sum=0;
              }
              let value=row[element];
              if (!elementTable.dates.includes(row.datetime)) {
                elementTable.dates.push(row.datetime)
              }
              a2[row.datetime]=value

              if (Number.isFinite(value)) {
                a2.count++;
                if (value>0) a2.countNonZero++;
                a2.sum+=value;
                if (value>a2.max) a2.max=value;
                if (value<a2.min) a2.min=value;
              }


              return a2;
            },{});
            elementRows["resolvedAddress"]=table.resolvedAddress;
            elementRows["stationDistance"]=table.stationDistance;
            a1.push(elementRows);
            return a1;
          }, [])
        ;

        a.push(elementTable);
        return a;
      }, []);

      me.viewElement=retVal && retVal.reduce(function(a,d) {
        if (a || !d) return a;
        if (!me.viewElement && d) return d;
        return d.element===me.viewElement.element?d:null;
      }, null);


      //if (!me.viewElement) {
       // me.viewElement=retVal && retVal[0];
      //}
      return retVal;
    },
    tables() {
      let me=this;
      if (!me.queryData || !me.queryData.days || !me.queryData.days.length) return [];

      let retVal=[];
      retVal.push(me.queryData);

      if (me.queryData.locations && me.queryData.locations.length) {
        retVal=retVal.concat(me.queryData.locations);
      }
     
      if (retVal) {
        retVal.forEach(function(d,i) {
          let count=0, sum=0;

          if (!d.stations || !Object.keys(d.stations)) return;

          Object.keys(d.stations).forEach(function(stationId) {
            let stationInfo=me.queryData.stations[stationId];
            if (!stationInfo || !Number.isFinite(stationInfo.distance)) return;
            sum+=stationInfo.distance;
            count++;
          });
          d.focus=i===0;
          d.stationDistance=sum/count;
        });

        retVal=retVal.sort(function(a,b) {
          a=a.focus?0:a.stationDistance;
          b=b.focus?0:b.stationDistance;
          return a-b;
        })
      }



      return retVal;

    },
  /*
    hours() {
      let me=this;
      if (!me.queryData || !me.queryData.days || !me.queryData.days.length) return [];
      return me.queryData.days.reduce(function(a,d) {
        if (d && d.hours && d.hours.length) {
          d.hours.forEach(h=> {
           
          })
          a=a.concat(d.hours);
        }
        return a;
      },[])
    },
    */
    columns() {
      let me=this;
      let rawColumns= me.queryDefn.elements.split(",");
      const hiddenCols=["datetimeEpoch","stations"];

      return rawColumns.filter(function(d) {
        return me.showAllColumns || !hiddenCols.includes(d);
      });
    },
    tableCols() {
      let me=this;
      if (!me.queryData || !me.queryData.days || !me.queryData.days.length) return [];
      return Object.keys(me.queryData.days[0]);
    },
    showDateRangeChooser() {
      return true;
    },
    hasLocationsHistory() {
      return this.locationsHistory && this.locationsHistory.length;
    },
  },
  watch: {

  },
   unmounted() {
    var me=this;
  },
  mounted() {
    var me=this;
   
    var vcCommunicator=window.vcCommunicator;
    if (!vcCommunicator) {
      console.log("No vcCommunicator");
      return;
    }
    me.sessionId=vcCommunicator.sessionId;
    me.sessionState=vcCommunicator.sessionState;
    vcCommunicator.addHandler('createsession', function (sessionId,sessionState) {
      me.sessionId=sessionId;
      me.sessionState=sessionState;
    
    
    });
     vcCommunicator.addHandler('terminatesession', function () {
       me.sessionId=null;
       me.sessionState=null;
    });
   

    var lastLocation=me.hasLocationsHistory && me.locationsHistory[0];
    var savedUnitGroup=VcLocationsStorage.getUnitGroup();
    
    if (savedUnitGroup) me.queryDefn.unitGroup=savedUnitGroup || "us";

    const vcconfig=window.vcconfig;
    if (vcconfig) {
     // if (window.vcconfig.location==="<?php echo $location ?>") window.vcconfig.location="Herndon,VA";
     // if (window.vcconfig.unitGroup==="<?php echo $unitGroup ?>") window.vcconfig.unitGroup="us";
     // if (window.vcconfig.startdate==="<?php echo $startDate ?>") window.vcconfig.startdate="last15days";
     // if (window.vcconfig.enddate==="<?php echo $endDate ?>") window.vcconfig.enddate="";

      
        if (vcconfig.location) {
          me.selectedLocation={
            location:vcconfig.location,
            name:null,
          };
        }
        if (vcconfig.unitGroup) {
          me.queryDefn.unitGroup=vcconfig.unitGroup;
        }
        if (vcconfig.startdate) {
          me.startdate=window.vcconfig.startdate;
        }
        if (vcconfig.focusType) {
          me.focusType=window.vcconfig.focusType;
        }
        if (vcconfig.rooturl) {
          me.rooturl=window.vcconfig.rooturl;
        }
        
        if (vcconfig.queryData) {
          me.queryData=vcconfig.queryData;
          me.refreshData(0);
        }

    }
    
    me.selectedLocation=me.selectedLocation || lastLocation;
   

  },
  components: {
    VcLocationChooser,
    DateRangeChooser,
    CommonModals
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .old {
      font-style: italic;
      opacity: 0.9;
  }
  .table-striped tbody  .error {
    font-weight: bold;
  
  }
  .table-striped tbody .error td {
      background-color: rgb(245, 212, 212) !important;
  }

  .elementTable td:nth-child(2), th:nth-child(2) {  
    font-weight: bold;
    /*font-size:1.2em;*/
  }

</style>